import { getNationalAveragesForHazardForShare } from '../services/api/generated/client';
import HHSRSScoreApi from '../services/api/HHSRSScoreApi';
import {
    getCalculatedScore,
    getLikelihoodScalePoints,
    getLikelihoodStartFromScalePoints,
} from '../services/hhsrs/HHSRSCalculator';
import { formatResponseErrorsForFormik } from '../services/http/errors';
import { setAlert } from './alerts';
import { setHazard } from './hazardsDefects';
import { getHHSRSScoring } from './inspectionDetail';

export const RESET = 'EDIT_SCORING/RESET';
export const TOGGLE_IS_LOADING = 'EDIT_SCORING/TOGGLE_IS_LOADING';
export const NATIONAL_AVERAGES_REFRESHED =
    'EDIT_SCORING/NATIONAL_AVERAGES_REFRESHED';
export const INITIAL_FORM_VALUES_REFRESHED =
    'EDIT_SCORING/INITIAL_FORM_VALUES_REFRESHED';
export const CALCULATED_SCORE_REFRESHED =
    'EDIT_SCORING/CALCULATED_SCORE_REFRESHED';
export const HARM_CLASS_TOGGLED = 'EDIT_SCORING/HARM_CLASS_TOGGLED';
export const LIKELIHOOD_SCALE_POINTS_REFRESHED =
    'EDIT_SCORING/LIKELIHOOD_SCALE_POINTS_REFRESHED';
export const SET_IS_REMOVING_WARNING_FLAG =
    'EDIT_SCORING/SET_IS_REMOVING_WARNING_FLAG';

export const nationalAveragesRefreshed = (nationalAverages) => ({
    type: NATIONAL_AVERAGES_REFRESHED,
    nationalAverages,
});

export const initialFormValuesRefreshed = (initialValues) => ({
    type: INITIAL_FORM_VALUES_REFRESHED,
    initialValues,
});

export const calculatedScoreRefreshed = (calculatedScore) => ({
    type: CALCULATED_SCORE_REFRESHED,
    calculatedScore,
});

export const likelihoodScalePointsRefreshed = (likelihoodScalePoints) => ({
    type: LIKELIHOOD_SCALE_POINTS_REFRESHED,
    likelihoodScalePoints,
});

export const harmClassToggled = (toggledClass) => ({
    type: HARM_CLASS_TOGGLED,
    toggledClass,
});

export const isLoadingToggled = (isLoading) => ({
    type: TOGGLE_IS_LOADING,
    isLoading,
});

export const setIsRemovingWarningFlag = (isRemoving) => ({
    type: SET_IS_REMOVING_WARNING_FLAG,
    isRemoving,
});

export const reset = () => ({ type: RESET });

export const getNationalAverages = (inspection, hazard) => async (dispatch, getState) => {
    try {
        dispatch(isLoadingToggled(true));
        const { token } = getState().pages.inspectionDetail;

        const {
            data: { data },
        } = token
                ? await getNationalAveragesForHazardForShare(
                    token,
                    hazard.id
                )
                : await HHSRSScoreApi.getNationalAveragesForHazard(
                    inspection.id,
                    hazard.id
                )

        const likelihood = getLikelihoodStartFromScalePoints(
            hazard.scoring?.likelihood ?? data.likelihood
        );

        const initialFormValues = {
            hazard_id: hazard.id,
            likelihood,
            classi_rating: hazard.scoring?.classi_rating ?? data.classi_rating,
            classii_rating:
                hazard.scoring?.classii_rating ?? data.classii_rating,
            classiii_rating:
                hazard.scoring?.classiii_rating ?? data.classiii_rating,
            classiv_rating:
                hazard.scoring?.classiv_rating ?? data.classiv_rating,
            score: hazard.scoring?.score ?? '',
            band: hazard.scoring?.band ?? '',
            harms_justification: hazard.scoring?.harms_justification ?? '',
            likelihood_justification:
                hazard.scoring?.likelihood_justification ?? '',
            most_likely_rating: hazard.scoring?.most_likely_rating ?? '',
        };

        dispatch(nationalAveragesRefreshed(data));
        dispatch(
            likelihoodScalePointsRefreshed(
                getLikelihoodScalePoints(
                    getLikelihoodStartFromScalePoints(data.likelihood)
                )
            )
        );
        dispatch(initialFormValuesRefreshed(initialFormValues));
        dispatch(
            calculatedScoreRefreshed(getCalculatedScore(initialFormValues))
        );
    } catch ({ response }) {
        dispatch(
            setAlert(
                'Unable to fetch national averages for hazard.',
                'error',
                'scoring'
            )
        );
    } finally {
        dispatch(isLoadingToggled(false));
    }
};

export const refreshCalculatedScore = (values) => async (dispatch) => {
    dispatch(calculatedScoreRefreshed(getCalculatedScore(values)));
};

export const onSubmit =
    (values, { setSubmitting, setErrors }, inspection, onSuccess) =>
    async (dispatch, getState) => {
        try {
            const { band, score } =
                getState().pages.editScoring.calculatedScore;

            await HHSRSScoreApi.update(inspection.id, {
                ...values,
                band,
                score,
            });
            dispatch(setAlert('HHSRS scoring updated.', 'success', 'scoring'));
            onSuccess();
        } catch ({ response }) {
            const formattedErrors = formatResponseErrorsForFormik(
                response.data.errors
            );
            setErrors(formattedErrors);
            setSubmitting(false);
        }
    };

export const clearRescoreWarning = (hazard, inspection) => async (dispatch) => {
    try {
        dispatch(setIsRemovingWarningFlag(true));

        const {
            data: { data },
        } = await HHSRSScoreApi.clearRescoreWarning(hazard.id, inspection.id);

        dispatch(getHHSRSScoring(inspection.id));
        dispatch(setIsRemovingWarningFlag(false));
        dispatch(setHazard({
            ...hazard,
            scoring: {
                ...hazard.scoring,
                requires_rescore: false
            }
        }));
    } catch ({ response }) {
        dispatch(
            setAlert(
                'The re-score warning could not be cleared. Please try again. If the problem persists please contact a member of the Housing App team.',
                'warning',
                'error'
            )
        );
    }
};
